<template>
    <v-dialog v-model="isShowDialog" max-width="800px" @click:outside="closePopup">
      <v-card>
        <v-card-title>
          <span class="title">{{title}}</span>
        </v-card-title>
        <v-card-text>
            <div class="flex w-full h-screen items-center justify-center text-center file-drag-area" id="app">
                <div class="p-12 bg-gray-100 border border-gray-300" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                    <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle" style="display:none" class="w-px h-px opacity-0 overflow-hidden absolute" @input="onChange" ref="file" />
                
                    <label for="assetsFieldHandle" class="block cursor-pointer">
                    <div>
                        <span class="underline" style="line-height: 100px;">Kéo tệp tin vào đây hoặc bấm vào đây để chọn tệp.</span> 
                    </div>
                    </label>
                    <ul class="mt-4" v-if="this.filelist.length" v-cloak>
                      <li class="text-sm p-1" v-for="file in filelist" :key="file.name">
                          {{ file.name }}<button class="ml-2 remove" type="button" @click="remove(filelist.indexOf(file))" title="Xóa file">xóa file</button>
                      </li>
                    </ul>
                </div>
            </div>
            <v-layout row wrap>
              <v-flex lg12>
                <hpo-filter
                  :headers="headers"
                  :viewName="viewName"
                  v-on:applyFilter="applyFilter"
                  v-on:quickFilter="quickFilter"
                ></hpo-filter>    
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :options.sync="pagination"
                  :server-items-length="total_rows"
                  :footer-props="items_per_page"
                  :must-sort="true"
                  :loading="loading"
                  :mobile-breakpoint="100"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.id }}</td>
                      <td><img :src="'/'+item.path" alt="" style="height: 56px; width: 56px;"></td>
                      <td> {{ item.filename }}</td>
                      <td>
                        {{ item.created_at | display_date }}
                      </td>
                      <td class="text-center">
                        <v-icon medium class="mr-2" @click="deleteItem(item.id)" >delete</v-icon>
                        <v-icon medium class="mr-2" @click="openItem(item)">check_circle_outline</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="closePopup">Exit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice } from "@/commons/utils";
export default {
  name: "upload-file-popup",
  components: {
    "hpo-filter": Filtering,
  },
  data() {
    return {
      viewName: "media_list",
      isShowDialog: false,
      filelist: [], // Store our uploaded files
      headers: [
        {
          text: "ID",
          value: "id",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Ảnh",
          value: "path",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên tệp",
          value: "filename",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Ngày tạo",
          value: "created_at",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Date"],
        },
        {
          text: "",
        }
      ],
      pagination: {...configs.PAGINATION, itemsPerPage: 10},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: [],
    };
  },
  props: ["dialogUpload", "title", "temp_file"],
  watch: {
    pagination: {
      handler: function (val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true,
    },
    dialogUpload() {
      this.isShowDialog = this.dialogUpload;
      if(this.dialogUpload) {
        this.filter_data();
      }
    }
  },
  computed: { 
    ...mapState({
      items: (state) => state.files.all.data,
      total_rows: (state) => state.files.all.total,
      loading: (state) => state.files.loading,
      currentItem: (state) => state.files.selected
    })
  },
  methods: {
    filter_data: function () {
      var param = {
        pagination: this.pagination,
        filter: [...this.filterConditions],
        quickFilter: this.quickFilterConditions,
      };
      this.$store.dispatch("files/getList", param);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    deleteItem: function (id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },
    closePopup() {
      this.$emit("closePopup");
    },
    openItem(item) {
      this.$emit("chooseFile", item);
    },
    onChange() {
      this.filelist = [...this.$refs.file.files];
      this.$refs.file.value = null;
      
      for(const f of this.filelist) {
          const formData = new FormData();
          formData.append('attach_file', f);
          formData.append('filename', f.name);
          const lastDot = f.name.lastIndexOf('.');
          const ext = f.name.substring(lastDot + 1);
          formData.append('extension', ext);
          this.$store.dispatch("files/upload_file", formData);
      }
    },
    remove(i) {
      this.filelist.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('bg-green-300')) {
        event.currentTarget.classList.remove('bg-gray-100');
        event.currentTarget.classList.add('bg-green-300');
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('bg-green-300');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('bg-green-300');
    }   
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", (id) => {
      this.$store.dispatch("files/removeDetail", id);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  },
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}

ul {
  list-style: none
}
.remove{
    color: rgb(245, 8, 8)
}
.file-drag-area {
  height: 100px;
  border: 1px solid #a7a7a7;
  margin-bottom: 20px;
}
</style>